// TODO -> add type patterns for this and other components
// Try to have a basic resuable Foundationscomponet Type
// add onclick -> disable until action is complete functionality
// import { useState } from "react"
import { FoundationsButtonType } from '../Types/FoundationsTypes'
import { FoundationsTooltip } from './tooltip'
import { FoundationsGeneric } from './FoundationsGeneric'
import { getBaseUrl } from '../Utils'

export function FoundationsButton(props: FoundationsButtonType) {
    // const [showLoader, setShowLoader] = useState(false)
    const buttonStyle = {
        visibility: (props.hideText ? 'hidden' : 'visible') as 'visible' | 'hidden',
    }

    const loaderStyle = {
        display: 'inline-block',
    }

    return (
        <FoundationsGeneric
            id={props.id + '_container'}
            customStyle={props.customStyle}
            classes={'d-block ' + (props.classes || '')}
        >
            <button
                type={props.type ? props.type : 'button'}
                id={props.id}
                className={(props.buttonClasses || '') + ' d-inline-block'}
                data-dismiss={props.doDismiss}
                onClick={props.onClick}
                disabled={props.disabled || props.isLoading ? true : false}
                tabIndex={props.tabIndex}
                ref={props.buttonRef}
                title={props.title}
            >
                <span style={buttonStyle}>{props.children}</span>
            </button>
            {props.toolTipText !== undefined && (
                <span className="text-right mt-1 ml-1 tooltip-icons">
                    <FoundationsTooltip
                        id={'tooltip_icon_' + props.id}
                        text={props.toolTipText}
                        style={{
                            transform: 'translate(30%, 10%)',
                            fontWeight: 'bold',
                        }}
                    />
                </span>
            )}
            {props.isLoading ? (
                // TODO -> change loading to be a skeleton or other kind of loader, don't use the gif anymore
                <span
                    id={props.id + '_loader'}
                    className={'app-account-loading ' + props.loaderClasses}
                    style={loaderStyle}
                >
                    <span className="ajax-loading-box-small-plain">
                        <img
                            src={getBaseUrl() + '/images/ajax-loader.gif'}
                            alt="..."
                            className="image-loading"
                        />
                    </span>
                </span>
            ) : (
                <></>
            )}
        </FoundationsGeneric>
    )
}
